import cloneDeep from 'lodash/cloneDeep';
import { getPercentageMetricByKey } from '@utils/metrics/metricHelpers';

export const query = {
  metrics: [], // append metric name selected in metrics panel
  interval: '2018-12-19T22:35:18.907Z/2018-12-20T22:35:18.907Z',
  filter: [],
  groupBy: [
    '', // dimension name
  ],
  orderBy: 'desc',
  percentile: 95,
};

const initialState = {
  dimension: '',
  query: null,
  response: null,
  isFetching: true,
  errorCode: 0,
  errorMsg: '',
  invalid: true,
};

export const buildBenchmarkQuery = ({
  dimension,
  columns,
  filter,
  interval,
  supportedMetrics = [],
}) => {
  // unit toggle metrics
  const invertedMetrics: any = [];

  columns.forEach((m) => {
    const percentageMetric = getPercentageMetricByKey({ metricKey: m });
    if (percentageMetric) {
      invertedMetrics.push(percentageMetric);
    }
  });
  // Remove the non supported metrics
  if (supportedMetrics.length > 0) {
    columns = [...columns, ...invertedMetrics].filter((column) =>
      supportedMetrics.includes(column),
    );
  } else {
    columns = [];
  }
  if (columns.length > 0) {
    const q = {
      ...cloneDeep(query),
      interval,
      filter,
      metrics: [...columns],
      groupBy: dimension ? [dimension] : [],
    };
    return {
      query: q,
    };
  } else {
    return null;
  }
};

export const createDimension = (dimension) => ({
  ...cloneDeep(initialState),
  dimension,
});
